/**
 * Created by ren on 14/06/2017.
 */
import isEmpty from 'lodash/isEmpty';
import * as ActionType from '../constants/constant_action_types';

const INITIAL_STATE = {
    data   : {},
    isFetching : false
};

export function currencyReducer( state = INITIAL_STATE, action ){
    switch(action.type) {

        case ActionType.SET_CURRENCY_CONTENT: {

            if( action.payload ){
                if( isEmpty( action.payload.denominations ) ){
                    action.payload.denominations = [{}];
                }

                return {  ...state,
                    data       : action.payload,
                    isFetching : false
                };
            }

            return { ...state,
                data : {
                    active        : true,
                    denominations : [{}]
                },
                isFetching : false
            };
        }

        case ActionType.CLEAR_CURRENCY_CONTENT: {
            return { ...state, data : {}, isFetching : true };
        }

        case ActionType.SET_CURRENCY_CONTENT_IN_PROGRESS: {
            return { ...state, isFetching : true };
        }

        default:
            return state;
    }
}